// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderSummaryCosts_container__RVfIl","oldPrice":"OrderSummaryCosts_oldPrice__Xa3dT","discountBanner":"OrderSummaryCosts_discountBanner__XiGsx"};